import React, { useMemo } from 'react';

import { Actions, Action, DeleteIcon } from '@gogame/components';
import { useGridApiContext } from '@gogame/data-grid';

import { useBatchDeleteLookalikeAudience } from 'scenes/CustomAudiences/LookalikeAudiences/data';

const BatchToolbar = ({ selectedValues }) => {
  const {
    current: { getRow },
  } = useGridApiContext();

  const selectedRows = useMemo(() => {
    if (!getRow) {
      return selectedValues.map((id) => ({ id }));
    }

    return selectedValues.map((id) => {
      const { name } = getRow(id);

      return {
        id,
        name,
      };
    });
  }, [selectedValues, getRow]);

  const [batchDelete] = useBatchDeleteLookalikeAudience();

  const handleBatchDelete = async (_e, selectedRows) => {
    await batchDelete(selectedRows);
  };

  return (
    <Actions>
      <Action
        label={'Delete'}
        icon={<DeleteIcon />}
        onClick={(e) => handleBatchDelete(e, selectedRows)}
      />
    </Actions>
  );
};

export default BatchToolbar;
